import styled from 'styled-components';

const SELECTOR_STROKE = '#8dbbb8';
const TEXT_PRIMARY = '#040404';
const TEXT_SECONDARY = '#464646';

const SELECTED_STROKE = '#ec008c';
/** Pearl “Most Popular” card border from Figma (Pearl Connect plan picker) */
const POPULAR_TIER_STROKE = '#d62866';

const TAGLINE_ACCENT_TEAL = '#4a8280';

export const PlanCard = styled.div`
    position: relative;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    flex: 1 1 0;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    background: #fff;
    border-radius: 8px;
    border: ${({ $isSelected, $isPopularTier }) => {
        if ($isSelected) {
            return `2px solid ${$isPopularTier ? POPULAR_TIER_STROKE : SELECTED_STROKE}`;
        }
        if ($isPopularTier) {
            return `1px solid ${POPULAR_TIER_STROKE}`;
        }
        return `1px solid ${SELECTOR_STROKE}`;
    }};
    cursor: pointer;
    text-align: left;

    @media (max-width: 992px) {
        flex: 0 0 auto;
        width: 100%;
        max-width: 100%;
    }
`;

export const HiddenRadio = styled.input`
    position: absolute;
    opacity: 0;
    pointer-events: none;
    width: 0;
    height: 0;
`;

export const MainColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

export const LabelPricing = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
`;

export const PlanHeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
`;

export const PlanName = styled.p`
    margin: 0;
    flex: 1 1 auto;
    min-width: 0;
    font-family: 'Objektiv Mk2 Bold', 'Objektiv Mk2', sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    color: ${TEXT_PRIMARY};
`;

export const MostPopularBadge = styled.span`
    flex-shrink: 0;
    box-sizing: border-box;
    background: #b5e1cf;
    color: #153628;
    font-family: 'Objektiv Mk2 Bold', 'Objektiv Mk2', sans-serif;
    font-size: 12px;
    font-weight: 700;
    line-height: 20px;
    padding: 4px 12px;
    border-radius: 60px;
    white-space: nowrap;
`;

export const PlanPrice = styled.p`
    margin: 0;
    width: 100%;
    font-family: 'Objektiv Mk2', sans-serif;
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
    color: ${TEXT_PRIMARY};
`;

export const PlanTagline = styled.div`
    margin: 0;
    width: 100%;
    font-family: 'Objektiv Mk2', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    color: ${({ $pearlPink }) => ($pearlPink ? POPULAR_TIER_STROKE : TAGLINE_ACCENT_TEAL)};
`;

export const PlanDescription = styled.p`
    margin: 0;
    width: 100%;
    font-family: 'Objektiv Mk2', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: ${TEXT_SECONDARY};
`;

export const IncludedBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const IncludedRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
`;

export const CheckmarkIconSlot = styled.span`
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;

    svg {
        display: block;
        width: 16px;
        height: 16px;
    }
`;

export const IncludedText = styled.span`
    font-family: 'Objektiv Mk2', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: ${TEXT_SECONDARY};
`;

const PRIMARY_CTA_FILL = '#2b4344';

export const PlanCtaButton = styled.button`
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    padding: 12px 20px;
    border-radius: 8px;
    font-family: 'Objektiv Mk2 Bold', 'Objektiv Mk2', sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
    flex-shrink: 0;

    ${({ $variant }) =>
        $variant === 'primary'
            ? `
        border: 1px solid ${PRIMARY_CTA_FILL};
        background: ${PRIMARY_CTA_FILL};
        color: #fff;
    `
            : `
        border: 1px solid ${SELECTOR_STROKE};
        background: #fff;
        color: ${TEXT_PRIMARY};
    `}

    &:focus-visible {
        outline: 2px solid ${TAGLINE_ACCENT_TEAL};
        outline-offset: 2px;
    }
`;
